import { useEffect, useState } from "react";
import {  Modal, SelectPicker } from "rsuite";
import { Divider } from "antd";

import { appCRUD } from "../../../actions/app";
import { number } from "../../../utils";


export const EnrollmentView = (props) => {
  const { open, setOpen, index, dataId } = props;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadCourse, setLoadCourse] = useState(false);

  const [course, setCourse] = useState(null);
  const [enrolledCourse, setEnrolledCourse] = useState([]);

  useEffect(() => {
    setLoadCourse(true);
    setTimeout(() => {
      appCRUD
        .loadEnrolledCourse()
        .then((resp) => {
          setEnrolledCourse(resp.data);
        })
        .catch(() => {})
        .finally(() => {
          setLoadCourse(false);
        });
    }, 1000);
  }, [index]);

  useEffect(() => {
    if(dataId && course){
        setLoading(true);
        setTimeout(() => {
            appCRUD.loadEnrollmentItemByCourse(dataId, course).then((resp) => {
                setData(resp.data);
            })
            .catch(() => {})
            .finally(() => {
                setLoading(false);
            })
        }, 1000)
    }
  }, [course, dataId]);

  const totalStudents = data.reduce((sum, item) => sum + item.student, 0);
  

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
          setCourse(null);
          setData([]);
        }}
        size="md"
      >
        <Modal.Header>
          <Modal.Title>Enrollment Programme</Modal.Title>
        </Modal.Header>
        <Divider />
        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SelectPicker
                  loading={loadCourse}
                  className="w-100"
                  data={enrolledCourse?.map((dt) => ({
                    value: dt,
                    label: dt,
                  }))}
                  placeholder="Select Course"
                  onChange={(value) => setCourse(value)}
                  onClean={() => {
                    setCourse(null);
                    setData([]);
                  }}
                />
                <hr />
              </div>
            </div>
            {loading ? (
              <p className="text-center text-primary h6">Please wait....</p>
            ) : data.length ? (
              <>
                <div className="row mt-2">
                  <div className="col-md-2 col-sm-12">
                    <p className="h6">Course</p>
                  </div>
                  <div className="col-md-1 col-sm-12">
                    <p className="h6 fw-bold">:</p>
                  </div>
                  <div className="col-md-9 col-sm-12">
                    <p className="h6 fw-bold">{course}</p>
                  </div>
                </div>
                <hr />
                <div className="row mt-2">
                  <div className="col-md-2 col-sm-12">
                    <p className="h6">Instructor</p>
                  </div>
                  <div className="col-md-1 col-sm-12">
                    <p className="h6 fw-bold">:</p>
                  </div>
                  <div className="col-md-9 col-sm-12">
                    <p className="h6 fw-bold">
                      {data.length ? data[0].instractor : null}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="row mt-2">
                  <div className="col-12">
                    <table className="table table-bordered table-striped table-hover table-responsive table-sm">
                      <thead className="table-head">
                        <tr>
                          <th>SN</th>
                          <th>Programme</th>
                          <th>No. Students</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((dt, i) => (
                          <tr>
                            <td>{i + 1}</td>
                            <td>{dt.programme.code}</td>
                            <td>{number.fNumber(dt.student)}</td>
                          </tr>
                        ))}
                        {data.length ? (
                          <tr>
                            <td></td>
                            <td>
                              <strong>Total Students</strong>
                            </td>
                            <td>
                              <strong>{totalStudents}</strong>
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </Modal.Body>
        <Divider style={{ marginTop: -10 }} />
        <Modal.Footer>
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-12 d-flex justify-content-start"></div>
              <div className="col-md-6 col-sm-12 d-flex justify-content-end">
                <button
                  onClick={() => {
                    setOpen(false);
                    setCourse(null);
                    setData([]);
                  }}
                  type="button"
                  className="btn btn-soft-danger me-3"
                >
                  <i class="ri-close-circle-line align-middle fs-16 me-2"></i>{" "}
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
